import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { useTranslation, type TranslationKey } from '@/i18n/i18n';

const ksefFaqs: { qKey: TranslationKey; aKey: TranslationKey }[] = [
  { qKey: 'ksef.faq.q1', aKey: 'ksef.faq.a1' },
  { qKey: 'ksef.faq.q2', aKey: 'ksef.faq.a2' },
  { qKey: 'ksef.faq.q3', aKey: 'ksef.faq.a3' },
  { qKey: 'ksef.faq.q4', aKey: 'ksef.faq.a4' },
  { qKey: 'ksef.faq.q5', aKey: 'ksef.faq.a5' },
  { qKey: 'ksef.faq.q6', aKey: 'ksef.faq.a6' },
];

export const KSeFPageFAQ = () => {
  const { t } = useTranslation();

  return (
    <section aria-labelledby="ksef-faq-heading" className="py-16 px-6 md:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 id="ksef-faq-heading" className="text-3xl md:text-5xl font-semibold mb-4">
            {t('ksef.faq.heading')}
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {ksefFaqs.map((faq) => (
            <AccordionItem
              key={faq.qKey}
              value={faq.qKey}
              className="border-2 rounded-lg px-6 bg-card"
            >
              <AccordionTrigger className="text-left font-semibold hover:no-underline py-6">
                {t(faq.qKey)}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                {t(faq.aKey)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
